<template>
    <div class="mt-4 text-sm">
        <div class="mb-2">
            {{ $t('btm.summary.consents_text') }}
        </div>

        <label class="mb-2">
            <input
                type="checkbox"
                class="mr-2"
                :checked="areAllConsentsChecked"
                @change="markAllConsents"
                v-if="consents"
            >

            {{ $t('consents.mark_all') }}
        </label>

        <div v-for="consent in consents" :key="consent.id">
            <label class="mb-1" :class="{'is-required': consent.required}">
                <input
                    type="checkbox"
                    class="mr-2"
                    :required="consent.required"
                    v-model="consent.checked"
                    v-on:change="onChange"
                >

                <span v-html="consent.label" />
            </label>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ConsentRepository from '@repositories/ConsentRepository';

    export default {
        data() {
            return {
                consents: null,
            };
        },

        computed: {
            ...mapGetters({

            }),

            areAllConsentsChecked() {
                if (!this.consents) {
                    return false;
                }

                let result = true;

                this.consents.forEach((consent) => {
                    if (!consent.checked) {
                        result = false;
                    }
                });

                return result;
            },
        },

        created() {
            ConsentRepository.list()
                .then((response) => {
                    this.consents = response.data.data;
                });
        },

        methods: {
            markAllConsents(event) {
                this.consents.forEach((consent) => {
                    this.$set(consent, 'checked', event.target.checked);
                    this.$forceUpdate();
                    this.$emit('update:consents', this.consents);
                });
            },

            onChange() {
                this.$emit('update:consents', this.consents);
            },
        },
    };
</script>
